import React, { Component } from 'react';
import { safeParse } from '../utils';
const Parser = safeParse;

import TAOS from "./../Taos";
import OffcanvasForm from './OffcanvasForm';

class App extends Component {
  state = {
    showForm: false,
    formTitle: ''
  };

  openForm = (title) => {
    this.setState({ showForm: true, formTitle: title });
  };

  closeForm = () => {
    this.setState({ showForm: false });
  };

  handleFormSuccess = (message) => {
    console.log('Form success:', message);
  };

  handleFormError = (error) => {
    console.error('Form error:', error);
  };

  render() {
    const data = this.props?.data || {}
    const katalog_top = data?.katalog_top || {}
    const { showForm, formTitle } = this.state;

    const items = katalog_top?.items?.filter(elm => elm?.v == '1') || [];

    return (
      <>
        <div className='mt-[70px] xl:mt-[80px]'>
          <div className='container'>
          <div className='flex items-center justify-center xl:justify-start gap-[10px] text-[14px]'>
            <div className='inline-flex items-center px-[15px] h-[38px] bg-[#F5F7F9] rounded-full gap-[5px]'>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.375 5.58008L8.9975 9.41258C11.5662 7.92468 13.0063 7.09048 15.575 5.60258" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 16.2088V9.40625" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7.44797 1.86094L3.44297 4.08094C2.53547 4.58344 1.79297 5.84344 1.79297 6.87844V11.1159C1.79297 12.1509 2.53547 13.4109 3.44297 13.9134L7.44797 16.1409C8.30297 16.6134 9.70547 16.6134 10.5605 16.1409L14.5655 13.9134C15.473 13.4109 16.2155 12.1509 16.2155 11.1159V6.87844C16.2155 5.84344 15.473 4.58344 14.5655 4.08094L10.5605 1.85344C9.69797 1.38094 8.30297 1.38094 7.44797 1.86094Z" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div className='tracking-[-0.04em] text-[#032432]/60 text-[14px] xl:text-[16px] whitespace-nowrap'>О продукции Химавангард</div>
            </div>
            <a href={katalog_top?.file} target='_blank' className='inline-flex items-center px-[15px] h-[38px] border-[#032432]/10 border-[1px] rounded-full gap-[5px]'>
              <div className='tracking-[-0.04em] text-[14px] xl:text-[16px] whitespace-nowrap'>Скачать каталог</div>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.99219 8.75977L8.91219 10.6798L10.8322 8.75977" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.91003 3V10.6275" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M15 9.13477C15 12.4498 12.75 15.1348 9 15.1348C5.25 15.1348 3 12.4498 3 9.13477" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </a>
          </div>
          <h2 className='font-medium mt-[20px] xl:mt-[30px] tracking-[-0.04em] text-[#032432] text-center xl:text-start text-[24px] xl:text-[36px]'>{Parser(katalog_top?.title)}</h2>
          <div className='flex flex-col xl:flex-row items-center justify-between gap-[30px] xl:gap-[20px] text-[14px] mt-[10px]'>
            <div className='text-black/60 text-center xl:text-start text-[14px] xl:text-[16px] tracking-[-0.02em]'>{Parser(katalog_top?.text)}</div>
            <a href={katalog_top?.url} className='flex items-center justify-center gap-[9px] w-full xl:w-auto h-[38px] bg-[#009EE3] xl:h-auto xl:bg-white rounded-full text-white xl:text-[#032432]/60'>
              <div className='text-[14px] xl:text-[16px] whitespace-nowrap'>Весь каталог</div>
              <svg width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.433105 0.25L3.60234 5.75L0.433105 11.25" stroke="currentColor" stroke-opacity="0.6"/>
              </svg>
            </a>
          </div>
          <div className='grid grid-cols-2 xl:grid-cols-5 gap-[19px] mt-[20px]'>
            {items.map((elm, k) => (
              <TAOS
                as="a"
                href={elm?.url}
                key={k}
                className="
                  group
                  duration-[300ms] taos:[transform:perspective(2500px)_rotateY(-100deg)] taos:invisible taos:[backface-visibility:hidden]
                "
                offset="300"
              >
                <div className='flex items-center justify-center overflow-hidden bg-[#F5F7F9] rounded-[15px] w-full h-[211px] xl:h-[271px] relative'>
                  {elm?.dir != '' &&
                    <div className='absolute top-[15px] xl:top-[27px] left-[15px] xl:left-[20px] text-[16px] xl:text-[18px] max-w-[160px] text-black'>{elm?.dir}</div>
                  }
                  <div className="absolute top-[15px] xl:top-[20px] right-[15px] xl:right-[20px] w-[30px] xl:w-[35px] h-[30px] xl:h-[35px] rounded-full bg-white flex items-center justify-center text-black text-[16px] xl:text-[18px] leading-none transition-all duration-300 cursor-pointer group-hover:bg-[#009EE3] group-hover:text-white">
                    <svg width="13" height="5" viewBox="0 0 13 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.25209 4.35598C9.40809 3.99598 9.57009 3.67798 9.73809 3.40198C9.90609 3.11398 10.0741 2.86798 10.2421 2.66398H9.39667e-05V1.69198H10.2421C10.0741 1.47598 9.90609 1.22998 9.73809 0.953984C9.57009 0.665984 9.40809 0.347984 9.25209 -1.61529e-05H10.0981C10.8541 0.875984 11.6521 1.52398 12.4921 1.94398V2.41198C11.6521 2.81998 10.8541 3.46798 10.0981 4.35598H9.25209Z" fill="currentColor"/>
                    </svg>
                  </div>
                  <img src={elm.img} alt={elm.name} width={126} height={144} className='xl:w-[220px] h-auto max-w-full' />
                </div>
                <div className='mt-[15px] xl:mt-[14px] text-[16px] xl:text-[18px] tracking-[-0.04em] text-[#032432] leading-none'>
                  {Parser(elm.name)}
                </div>
                {elm.name2 != '' &&
                  <div className='text-[#032432]/60 text-[12px] xl:text-[14px]'>{Parser(elm.name2)}</div>
                }
              </TAOS>
            ))}
          </div>
          </div>
        </div>

        <OffcanvasForm
          show={this.state.showForm}
          hide={this.closeForm}
          formTitle={this.state.formTitle}
          productName=""
          onSuccess={this.handleFormSuccess}
          onError={this.handleFormError}
        />
      </>
    );
  }
}

export default App;
